<template>
  <div
    class="mx-auto flex min-h-[calc(100dvh-64px)] max-w-3xl flex-col pb-2 md:h-[calc(100dvh-80px)] md:min-h-auto md:pb-10"
  >
    <div class="flex grow flex-col items-center justify-center">
      <h1
        class="text-center"
        :class="[
          title && 'text-title-large text-on-surface-variant',
          !title && 'text-headline-small md:text-display-small lg:text-display-medium',
        ]"
      >
        {{ $t('common.feedbackTo') + ' ' + receiverName }}
      </h1>
      <h2
        v-if="title"
        class="text-headline-small md:text-display-small lg:text-display-medium mb-2 text-center"
      >
        {{ title }}
      </h2>
      <div class="flex flex-row gap-1">
        <BaseChip :icon="perspective.icon" class="mt-2 mb-4">{{
          pickPluralForm(perspective.nameLong, 1)
        }}</BaseChip>
        <BaseChip icon="business" class="mt-2 mb-4">{{ organizationName }}</BaseChip>
      </div>
      <div v-if="message" class="mt-10 mb-20 flex max-w-xl flex-row gap-1">
        <div
          class="bg-primary-container text-on-primary-container flex h-10 w-10 shrink-0 grow-0 items-center justify-center overflow-hidden rounded-full"
        >
          <span>{{ receiverName[0] }}</span>
        </div>
        <div class="bg-surface-container-high rounded-large rounded-tl-extra-small grow p-3">
          <WysiwygTextFieldReadOnly :value="message" />
        </div>
      </div>

      <div class="flex w-full flex-row items-end justify-center">
        <BaseTextButton
          trailing-icon="play_arrow"
          :size="{ base: 'M', md: 'L' }"
          color="filled"
          @click="emits('skip-start-screen')"
          >Jetzt Feedback geben</BaseTextButton
        >
      </div>
      <div class="mt-3 flex flex-col items-center justify-center gap-2">
        <div class="text-on-surface-variant flex flex-row items-center">
          <BaseIcon size="18" class="mr-1">schedule</BaseIcon>
          <span class="text-body-medium">
            {{ $t('common.estimatedTime', { count: timeEstimate }) }}
          </span>
        </div>
        <div class="text-on-surface-variant flex flex-row items-center">
          <BaseIcon size="18" class="mr-1">lock</BaseIcon>
          <span class="text-body-medium">
            {{ $t('privacy.noAccountRequired') }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import type { JSONContent } from '@tiptap/vue-3'
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import WysiwygTextFieldReadOnly from '@/core/components/base/wysiwyg/WysiwygTextFieldReadOnly.vue'
  import BaseChip from '@/core/components/base/chip/BaseChip.vue'
  import { pickPluralForm } from '@/core/models/perspective-label'

  interface Props {
    receiverName: string
    organizationName: string
    timeEstimate: number
    message?: JSONContent
    title?: string
    perspective: {
      key: string
      nameLong: string
      nameShort: string
      icon: string
    }
  }

  defineProps<Props>()
  const emits = defineEmits<{
    (e: 'skip-start-screen'): void
  }>()
</script>
